import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, Loading, ImagePreview } from '../Library'
import { viewFeedback, markResolve } from '../Network/Feedback'
import dayjs from 'dayjs'
import { baseURL } from '../Network/Config'
import "./FeedbackDetail.css"
import { ModalContext } from '../Library/ModalContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk, faCheckCircle } from '@fortawesome/free-solid-svg-icons'

function FeedbackDetail() {
    const { id } = useParams()
    const modal = useContext(ModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    const [isLoading, setLoading] = useState(false)
    const [feedbackTitle, setFeedbackTitle] = useState("-")
    const [feedbackDetail, setFeedbackDetail] = useState("-")
    const [createdDatetime, setCreatedDatetime] = useState("")
    const [attachImage, setAttachImage] = useState(null)
    const [service, setService] = useState("-")
    const [user, setUser] = useState(null) 
    const [isSolved, setSolved] = useState(false)
    const [images, setImages] = useState([])
    const [response, setResponse] = useState("")

    const fetchData = () =>{
        setLoading(true)
        viewFeedback(id, 
            (data)=>{
                setFeedbackTitle(data.title)
                setFeedbackDetail(data.detail)
                setCreatedDatetime(data.created_date)
                setAttachImage(data.attachImagePath)
                setImages([{ imagePath: data.attachImagePath }])
                setService(data.service)
                setSolved(data.isSolved)
                setUser(data.user)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const markAsResolve = () =>{
        setLoading(true)
        markResolve(id, true, response,
            ()=>{
                fetchData()
            },
            (error)=>{
                setLoading(false)
            })
    }

    const previewImage = (key) =>{
        modal.setComponent(
            <ImagePreview
            initialKey={key}
            imagesSet={images}
            isGetBaseURL={true}
            />
        )
        modal.setHeader(lang.attach_image)
        modal.setDark(true)
        modal.setShow(true)
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="feedback-detail">
            { isLoading ? <Loading/> : null }
            <HeaderTitle 
            title={feedbackTitle} 
            description={
                <div style={{ color: isSolved ? 'green': 'orange' }}>
                    {isSolved ?
                    <FontAwesomeIcon icon={faCheckCircle}/> :
                    <FontAwesomeIcon icon={faAsterisk}/>
                    }
                    <span style={{ marginLeft: 10 }}>{isSolved ? lang.solved : lang.new_case}</span>
                </div>
            }
            backTo="/feedback" 
            isShowBack/>
            
            <div className="detail-block">
                <div className="feedback-title">{lang.detail} :</div>
                <div>
                    {feedbackDetail}
                </div>
            </div>
            <div className="detail-block">
                <div className="feedback-title">{lang.report_datetime} :</div>
                <div>
                    {dayjs(createdDatetime).format("D MMMM YYYY H:mm")}
                </div>
            </div>
            <div className="detail-block">
                <div className="feedback-title">{lang.service} :</div>
                <div>
                    {service}
                </div>
            </div>
            <div className="detail-block">
                <div className="feedback-title">{lang.user_report} :</div>
                <div>
                    {user?.firstName + " " + user?.lastName}
                </div>
                <div>
                    {user?.email}
                </div>
            </div>
            <div className="detail-block">
                <div className="feedback-title">{lang.attach_image} :</div>
                <div className="attach-image">
                    { attachImage !== null ?
                    <div className="attach-frame" onClick={()=>previewImage(0)}>
                        <img 
                        src={baseURL + attachImage} 
                        alt={baseURL + attachImage}/>
                    </div>
                    : 
                    <div>{lang.no_attach_image}</div>
                    }
                </div>
            </div>
            {/* <div className="solve-desc">
                {lang.mark_solve_desc}
            </div> */}
            <Button 
            variant="success"
            disabled={isSolved}
            style={{ marginTop: 23 }}
            onClick={()=>markAsResolve()}>
                {lang.mark_solve}
            </Button>
        </div>
    )
}

export default FeedbackDetail
